import {css} from "@panda/css";

import {PropertyPlanIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat} from "@pg-mono/string-utils";

import {PropertyViewRedirectButton} from "../../../atoms/PropertyBox/PropertyViewRedirectButton";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {hitGTMPropertySelectItem} from "../../../offer/tracking/ecommerce_events/property/hit_gtm_property_select_item";
import {IOfferBoxGTMSource} from "../../../offer/types/IOfferBoxGTMSource";
import {IOfferModalOffer} from "../../../offer/types/OfferModalOffer";
import {floorOrFloors} from "../../../property_list/PropertyListTableRow";
import {gtmEventPropertyListClick} from "../../../tracking/google_tag_manager/gtm_event_property_list";
import {gtmEventPropertyListPrice} from "../../../tracking/google_tag_manager/gtm_event_property_list_price";
import {IPropertySortOption} from "../../interfaces/IPropertySortOption";
import {IPropertyListProperty} from "../../types/PropertyListProperty";
import {cellA, cellB, cellC, cellD, cellE, PropertiesTableCell} from "./PropertiesTableCell";

type IProps = {
    property: IPropertyListProperty;
    index: number;
    offer: IOfferModalOffer;
    handlePlanClick: () => void;
    sort: IPropertySortOption | null;
    gtmMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
    isInModal?: boolean;
};

export function PropertiesTableRow(props: IProps) {
    const {property, index, offer, handlePlanClick, sort, gtmMeta, isInModal} = props;

    const responsiveLinkTarget = useResponsiveLinkTarget();

    const propertyLink = rpAppLink.property.detail.base({
        vendorSlug: offer.vendor.slug,
        offerSlug: offer.slug,
        offerId: offer.id,
        propertyId: property.id
    });

    const handleLinkClick = () => {
        gtmEventPropertyListClick("nieruchomosc");
        hitGTMPropertySelectItem({
            offer,
            property,
            listId: gtmMeta.listId,
            listName: gtmMeta.listName
        });
        gtmEventPropertyListPrice(index + 1);
    };

    return (
        <tr className={tableRow}>
            <PropertiesTableCell href={propertyLink} target={responsiveLinkTarget} onLinkClick={handleLinkClick} className={cellA}>
                {property.plan_image_pages && (
                    <button
                        className={css({p: 1})}
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handlePlanClick();
                        }}
                    >
                        <PropertyPlanIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                    </button>
                )}
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellB}
                sorted={Boolean(sort && sort.fieldName === "rooms")}
            >
                <Text variant="body_copy_2">{property.rooms}</Text>
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellC}
                sorted={Boolean(sort && sort.fieldName === "floor")}
            >
                <Text variant="body_copy_2">{floorOrFloors(offer.type, property.floors, property.floor)}</Text>
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellD}
                sorted={Boolean(sort && sort.fieldName === "area")}
            >
                <Text variant="body_copy_2">{areaFormat(property.area, {precision: 2})}</Text>
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellE}
                sorted={Boolean(sort && sort.fieldName === "price")}
            >
                <div onClick={(e) => e.stopPropagation()}>
                    <PropertyViewRedirectButton buttonVariant="highlight_primary" property={property} isInModal={isInModal} link={propertyLink} />
                </div>
            </PropertiesTableCell>
        </tr>
    );
}

const tableRow = css({
    "&:nth-of-type(odd)": {
        background: "var(--colors-gray-200)"
    },
    "&:nth-of-type(even)": {
        background: "var(--colors-gray-100)"
    }
});
import {css} from "@panda/css";

import {PropertyPlanIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {areaFormat} from "@pg-mono/string-utils";

import {PropertyViewRedirectButton} from "../../../atoms/PropertyBox/PropertyViewRedirectButton";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {hitGTMPropertySelectItem} from "../../../offer/tracking/ecommerce_events/property/hit_gtm_property_select_item";
import {IOfferBoxGTMSource} from "../../../offer/types/IOfferBoxGTMSource";
import {IOfferModalOffer} from "../../../offer/types/OfferModalOffer";
import {floorOrFloors} from "../../../property_list/PropertyListTableRow";
import {gtmEventPropertyListClick} from "../../../tracking/google_tag_manager/gtm_event_property_list";
import {gtmEventPropertyListPrice} from "../../../tracking/google_tag_manager/gtm_event_property_list_price";
import {IPropertySortOption} from "../../interfaces/IPropertySortOption";
import {IPropertyListProperty} from "../../types/PropertyListProperty";
import {cellA, cellB, cellC, cellD, cellE, PropertiesTableCell} from "./PropertiesTableCell";

type IProps = {
    property: IPropertyListProperty;
    index: number;
    offer: IOfferModalOffer;
    handlePlanClick: () => void;
    sort: IPropertySortOption | null;
    gtmMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
    isInModal?: boolean;
};

export function PropertiesTableRow(props: IProps) {
    const {property, index, offer, handlePlanClick, sort, gtmMeta, isInModal} = props;

    const responsiveLinkTarget = useResponsiveLinkTarget();

    const propertyLink = rpAppLink.property.detail.base({
        vendorSlug: offer.vendor.slug,
        offerSlug: offer.slug,
        offerId: offer.id,
        propertyId: property.id
    });

    const handleLinkClick = () => {
        gtmEventPropertyListClick("nieruchomosc");
        hitGTMPropertySelectItem({
            offer,
            property,
            listId: gtmMeta.listId,
            listName: gtmMeta.listName
        });
        gtmEventPropertyListPrice(index + 1);
    };

    return (
        <tr className={tableRow}>
            <PropertiesTableCell href={propertyLink} target={responsiveLinkTarget} onLinkClick={handleLinkClick} className={cellA}>
                {property.plan_image_pages && (
                    <button
                        className={css({p: 1})}
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handlePlanClick();
                        }}
                    >
                        <PropertyPlanIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                    </button>
                )}
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellB}
                sorted={Boolean(sort && sort.fieldName === "rooms")}
            >
                <Text variant="body_copy_2">{property.rooms}</Text>
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellC}
                sorted={Boolean(sort && sort.fieldName === "floor")}
            >
                <Text variant="body_copy_2">{floorOrFloors(offer.type, property.floors, property.floor)}</Text>
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellD}
                sorted={Boolean(sort && sort.fieldName === "area")}
            >
                <Text variant="body_copy_2">{areaFormat(property.area, {precision: 2})}</Text>
            </PropertiesTableCell>

            <PropertiesTableCell
                href={propertyLink}
                target={responsiveLinkTarget}
                onLinkClick={handleLinkClick}
                className={cellE}
                sorted={Boolean(sort && sort.fieldName === "price")}
            >
                <div onClick={(e) => e.stopPropagation()}>
                    <PropertyViewRedirectButton buttonVariant="highlight_primary" property={property} isInModal={isInModal} link={propertyLink} />
                </div>
            </PropertiesTableCell>
        </tr>
    );
}

const tableRow = css({
    "&:nth-of-type(odd)": {
        background: "var(--colors-gray-200)"
    },
    "&:nth-of-type(even)": {
        background: "var(--colors-gray-100)"
    }
});
